export default class LiveChatModule {
    constructor(element) {
        this.passedElement = element;
        this.searchQuery = "";
        this.init();
    }

    init = () => {
        if (!this.initialised) {
            this.initialised = true;
            this.getElements();
            this.addEventListeners();
            this.chatCta;
        }
    }

    getElements = () => {
        this.chatCta = this.passedElement.querySelector('.talkToUs');
    }

    addEventListeners = () => {
      //Add all event listeners bellow
        this.chatCta.addEventListener('click', (e) => {
            e.preventDefault();
            if ( Intercom ) {
                Intercom('showNewMessage');
            } else {
                console.warn("Intercom not found");
            }
        });
    }

}